import React from "react";
import "./style.less";


const Welfare = props => {
  return (
      <div className="welfareShow">
        {props.name === "" ? "" :
        <div className="head">
          <div className="line"></div>
          <span className="type">{props.name}</span>
          <div className="line"></div>
        </div>}
        <img className={props.name === "" ? "image2" : "image1" }alt="example" src={props.src} />
        {props.name === "" ? "" :<div className="welfareTitle1">{props.title1}</div>}
        <div className= "welfareTitle2">{props.title2}</div>
      </div>
  );
};

export default Welfare;
